import ExitHeader from './ExitHeader';
export default ExitHeader;
